module.exports = __webpack_public_path__ + "img/logo_vertical.a6c02a5a.png";